import { Component } from '@angular/core';
import { first } from 'rxjs/operators';
import { DashboardService } from '../../_services/dashboard.service';

@Component({ selector: 'results', templateUrl: 'results.component.html' })
export class ResultsComponent {

    results: any = [];

    constructor(private dashboardService: DashboardService ){}

    ngOnInit() {
        this.dashboardService.getDashboardJourney().pipe(first()).subscribe(data => {
            data.map(x => {
                let course = x;
                
                if(course.finished){
                    course.percentage = 100;
                    this.results.push(course);    
                }
                else {
                    course.percentage = x.currentSection * 100 / x.totalSections;
                }
                
            });
            
        });
    }

}